import React from "react";
import { Navigate } from "react-router-dom";

// pages (same imports as before)
import UserProfile from "../pages/Authentication/user-profile";
import Home from "pages/Home";
import ProductsPage from "pages/ProductsPage";
import ResourcesPage from "pages/ResourcesPage";
import AboutPage from "pages/AboutPage";
import MediaPage from "pages/MediaPage";
import InfoHubPage from "pages/InfoHubPage";
import ContactPage from "pages/ContactPage";
import TermsPage from "pages/TermsPage";
import SupportPage from "pages/SupportPage";
import Login from "../pages/Authentication/Login";
import Signup from "pages/Authentication/Signup";
import ResetPassword from "pages/Authentication/ResetPassword";
import SetPassword from "pages/Authentication/SetPassword";
import Logout from "../pages/Authentication/Logout";

import Dashboard from "../pages/Dashboard";
import CompanyDashboard from "pages/Dashboard/CompanyDashboard";
import BlacklistDashboard from "pages/Dashboard/BlacklistDashboard";
import DistributorWhitelistDashboard from "pages/Dashboard/DistributorWhitelistDashboard";
import Company from "../pages/Company";
import DocumentDashboard from "pages/Dashboard/DocumentDashboard";
import Document from "pages/Document";
import Users from "pages/Users";
import AddUser from "../pages/AddUser";
import BasicTables from "../pages/Tables/BasicTables";
import DatatableTables from "../pages/Tables/DatatableTables";
import DocViewer from "pages/DocViewer";
import ChangePassword from "../pages/Authentication/ChangePassword";
import RoleRedirect from "components/RoleRedirect";
import MustReadPage from "pages/MustRead";
import MustReadViewer from "pages/MustRead/MustReadViewer";
import MustReadAdmin from "pages/MustReadAdmin";

// 🔑 role rules:
// 1 => all
// 2 => all except companies
// 3 => only dashboard, documents, view-document

const authProtectedRoutes = [
  // dashboard  
  { path: "/dashboard", component: <Dashboard />, roles: [1, 2] },
  // home for role 3 and distributors (role 4)
  { path: "/home/:slug", component: <Dashboard />, roles: [3, 4] },
  { path: "/home", component: <Dashboard />, roles: [3, 4] },

  // companies 
  { path: "/companies", component: <CompanyDashboard />, roles: [1] },
  { path: "/add-company", component: <Company />, roles: [1] },
  { path: "/company/:id", component: <Company />, roles: [1] },

  { path: "/blacklist", component: <BlacklistDashboard />, roles: [1, 2] },
  { path: "/distributor-whitelist", component: <DistributorWhitelistDashboard />, roles: [1, 2] },

  // documents
  { path: "/resources", component: <DocumentDashboard />, roles: [1, 2, 3, 4] },
  // { path: "/view-document", component: <DocViewer />, roles: [1, 2, 3] },
  { path: "/add-resource", component: <Document />, roles: [1, 2] },
  { path: "/resource/:id", component: <Document />, roles: [1, 2] },

  // users
  { path: "/users", component: <Users />, roles: [1, 2] },
  { path: "/add-user", component: <AddUser />, roles: [1, 2] },
  { path: "/user/:id", component: <AddUser />, roles: [1, 2] },
  // must read
  { path: "/must-read", component: <MustReadPage />, roles: [3, 4] },
  { path: "/must-read/:itemId", component: <MustReadViewer />, roles: [3, 4] },
  { path: "/must-read-docs", component: <MustReadAdmin />, roles: [1, 2] },
  { path: "/view-document/:id", component: <DocViewer />, roles: [1, 2, 3, 4] },
  { path: "/support", component: <SupportPage />, roles: [1, 2, 3, 4] },

  // profile 
  { path: "/profile", component: <UserProfile />, roles: [1, 2] },
  { path: "/change-password", component: <ChangePassword />, roles: [1, 2, 3, 4] },

  // tables
  { path: "/tables-basic", component: <BasicTables />, roles: [1, 2, 3, 4] },
  { path: "/tables-datatable", component: <DatatableTables />, roles: [1, 2, 3, 4] },

  // default redirect
  { path: "/", exact: true, component: <RoleRedirect />, roles: [1, 2, 3, 4] },
];

const publicRoutes = [
  // { path: "/", component: <Home /> },
  // { path: "/products", component: <ProductsPage /> },
  // { path: "/resources", component: <ResourcesPage /> },
  // { path: "/about", component: <AboutPage /> },
  // { path: "/media", component: <MediaPage /> },
  // { path: "/info-hub", component: <InfoHubPage /> },
  // { path: "/contact", component: <ContactPage /> },
  { path: "/signin", component: <Login /> },
  { path: "/admin", component: <Login /> },
  { path: "/reset-password", component: <ResetPassword /> },
  { path: "/set-password", component: <SetPassword /> },
  { path: "/signup", component: <Signup /> },
  { path: "/logout", component: <Logout /> },
  { path: "/terms", component: <TermsPage /> },
];

export { authProtectedRoutes, publicRoutes };
